import type { Messages } from '../en'

export const errors: Messages['errors'] = {
  validationError: 'A solicitação não é válida. Confira o formulário e tente novamente.',
  unauthorized: 'Sua sessão expirou. Entre novamente.',
  forbidden: 'Você não tem acesso a este item. Fale com o administrador se isso parecer um engano.',
  csrfFailed: 'Não foi possível verificar a solicitação. Recarregue a página e tente novamente.',
  notFound: 'Não encontrado — pode ter sido removido ou expirado.',
  payloadTooLarge: 'Os anexos são grandes demais. Remova alguns arquivos e tente novamente.',
  conflict: 'Esta execução mudou de estado — atualize a página para ver a situação atual.',
  rateLimited: 'Muitas solicitações. Aguarde um momento e tente novamente.',
  webauthnFailed: 'A verificação da chave de acesso falhou. Tente novamente.',
  emailChallengeGeneric: 'Código inválido ou expirado.',
  emailChallengeIncorrect: 'Código incorreto. Confira o e-mail e tente novamente.',
  emailChallengeExpired: 'Este código expirou. Solicite um novo.',
  emailChallengeUsed: 'Este código já foi usado. Solicite um novo.',
  emailChallengeTooMany: 'Muitas tentativas. Solicite um novo código.',
  notProvisioned: 'Sua conta ainda não tem acesso ao portal. Peça um convite ao administrador.',
  accessForbidden: 'Somente um administrador desta empresa pode gerenciar acessos.',
  accessStepUpRequired:
    'Você entrou com um código por e-mail. Para gerenciar acessos, saia, entre novamente e crie uma chave de acesso logo após o código (ou use a que você já tem).',
  memberNotFound: 'Essa pessoa não está mais nesta empresa. Recarregue a página.',
  lastAdmin: 'A empresa ficaria sem administrador. Torne outra pessoa administradora antes.',
  accessSelfChange: 'Você não pode alterar o seu próprio acesso. Peça a outro administrador.',
  inviteDomainNotAllowed:
    'Esse endereço está fora dos domínios de e-mail permitidos para a sua empresa. Confira o endereço ou peça à EVT para incluir o domínio.',
  passkeyResetNotAllowed:
    'Essa pessoa também pertence a outra empresa; somente um administrador da plataforma EVT pode redefinir as chaves de acesso dela.',
  tenantNotFound: 'Essa empresa não existe.',
  tenantExists: 'Já existe uma empresa com esse identificador.',
  upstreamFailed: 'O serviço está com problemas neste momento. Tente novamente em instantes.',
  upstreamMisconfigured: 'O serviço está mal configurado. Nossa equipe já foi notificada.',
  executionInFlight: 'Esta execução ainda está sendo processada. Tente novamente em um momento.',
  memoryNotFound: 'Essa memória não está mais lá — pode já ter sido removida.',
  memoryNotYours: 'Essa memória é da sua empresa, então só o administrador pode alterá-la.',
  memoryConflict: 'Essa memória mudou enquanto estava aberta. Recarregue a página e tente de novo.',
  memoryFull:
    'Não há mais espaço na memória deste Smith. Pare de usar uma das suas memórias, ou peça espaço ao seu administrador.',
  memoryUnavailable: 'As memórias estão indisponíveis agora. Tente de novo em instantes.',
  memoryNotConfigured: 'As memórias ainda não estão disponíveis para a sua conta.',
  memoryOff: 'Este Smith não está mais guardando memórias. Recarregue a página para ver os que estão.',
  memoryTooLong: 'O que você escreveu passa do tamanho de uma memória. Encurte e salve de novo.',
  memoryTitleRequired: 'Escreva a sua memória em uma frase no primeiro campo e salve de novo.',
  requesterUnresolved: 'Não conseguimos confirmar quem é você agora. Tente de novo em instantes.',
  unexpected: 'Algo inesperado deu errado. Tente novamente.',
  feedbackLinkInvalid: 'Este link de avaliação é inválido ou expirou.',
  feedbackUnavailable: 'A avaliação está indisponível no momento. Tente novamente em alguns minutos.',
  flowNotAvailable: 'Este fluxo não está disponível para a sua empresa. Escolha um em Fluxos.',
  flowNotOffered:
    'Um fluxo que você escolheu não é mais oferecido a esta empresa. Recarregue a página para ver os fluxos que ela pode ter.',
  flowAccessConflict:
    'Outra pessoa alterou os fluxos desta empresa enquanto você os editava. Recarregue para ver a alteração e escolha de novo.',

  // Arquivos (envio em partes, anexos por referência no fr-docs, entregas por referência). Nunca as palavras do
  // servidor: elas citam hosts, tamanhos e etapas internas escritas para um operador.
  attachmentTooLarge: 'Os arquivos são maiores do que um pedido pode levar. Remova alguns ou envie menos de cada vez.',
  attachmentFetchFailed: 'Não conseguimos ler um dos seus arquivos. Anexe-o de novo e tente outra vez.',
  attachmentIntegrityFailed:
    'Um dos seus arquivos não chegou inteiro. Anexe-o de novo e tente outra vez — o original no seu dispositivo está intacto.',
  attachmentSourceForbidden:
    'Não foi possível entregar um dos seus arquivos ao serviço. É um problema de configuração do nosso lado; fale com o suporte.',
  sandboxStagingFailed:
    'Não foi possível preparar seus arquivos para o trabalho, então nada foi feito com eles. Tente de novo em alguns minutos.',
  deliverableUnavailable:
    'Um dos arquivos produzidos por esta execução não pôde ser recuperado e não está nesta entrega. Peça-o de novo ou execute o pedido outra vez.',
  uploadNotFound: 'Este arquivo não está mais disponível. Remova-o e anexe-o de novo.',
  uploadExpired:
    'Um dos seus arquivos foi enviado há tempo demais e não está mais disponível. Remova-o, anexe-o de novo e envie outra vez.',
  uploadNotReady: 'Um arquivo ainda está sendo enviado. Espere terminar e envie de novo.',
  uploadPartInvalid: 'Uma parte de um arquivo não chegou corretamente. Remova o arquivo e anexe-o de novo.',
  uploadIncomplete: 'Um arquivo não terminou de ser enviado. Tente de novo ou remova-o e anexe-o outra vez.',
  uploadBusy: 'Muitos arquivos estão sendo enviados agora. O seu continua em instantes.',
  resultPending: 'A entrega ainda está sendo preparada. Ela aparece aqui em instantes.',
  resultNotFound: 'Os arquivos desta execução não estão disponíveis aqui.'
}
